<template>
  <div class="footer-nav">
    <div class="footer-nav-content">
      <div class="footer-nav-content-center">
        <div class="footer-columns">
          <div class="footer-column">
            <div class="footer-column-title">支持</div>
            <div class="footer-column-content">
              <div class="footer-column-item" @click="handleItemClick('orderStatus')" title="订单状态">订单状态</div>
              <div class="footer-column-item" @click="handleItemClick('enterpriseConsultant')" title="联系企业法律顾问">联系企业法律顾问</div>
              <div class="footer-column-item" @click="handleItemClick('privateConsultant')" title="联系私人法律顾问">联系私人法律顾问</div>
              <div class="footer-column-item" @click="handleItemClick('specialService')" title="寻找专项法律服务">寻找专项法律服务</div>
              <div class="footer-column-item" @click="handleItemClick('legalDocuments')" title="法律文书">法律文书</div>
            </div>
          </div>
          <div class="footer-column">
            <div class="footer-column-title">学习更多知识</div>
            <div class="footer-column-content">
              <div class="footer-column-item" v-for="item in bottomNavList" :key="item.id" @click="handleGo(item)" :title="item.knowledgeTitle">{{ item.knowledgeTitle }}</div>
            </div>
          </div>
        </div>
        <div class="tk">© 牛法顾信息科技(上海)有限公司保留所有权利。</div>
        <div class="tk">牛法顾网站、小程序本身不是律师事务所，不提供法律建议。使用我们的产品和服务受我们的 <span @click="goAgreement">用户协议</span> 和 <span @click="goAgreement1">隐私政策</span> 的约束。</div>
      </div>
    </div>

    <div class="back-top" @click="backTop">
      <div class="back-top-icon"></div>
      <div class="back-top-text">Top</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',
  data() {
    return {
      bottomNavList: []
    }
  },
  computed: {
    ...mapGetters('user', [
      'isLogin'
    ])
  },
  mounted() {
    this.getBottomNavList()
  },
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
        duration: 500
      });
    },
    handleGo(item) {
      this.$router.push({
        path: '/legaldetail',
        query: { categoryItem: item.id, temp: new Date().getTime() }
      })
    },
    handleItemClick(type) {
      const routes = {
        orderStatus: '/stage/myOrder',
        enterpriseConsultant: '/packageIntroduction',
        privateConsultant: '/packagePrivate',
        specialService: '/packageDetailsForDz',
        legalDocuments: '/legalinstrument',
        videoKnowledge: '/videoCourses',
        legalKnowledge: '/legalknowledge',
        legalIntroduction: '/legal-introduction'
      };

      if (type == 'orderStatus') {
        if (!this.isLogin) {
          window.dispatchEvent(new CustomEvent('showLoginDialog'))
          return
        }
      }

      if (routes[type]) {
        this.$router.push(routes[type]);
      }
    },
    goAgreement() {
      this.$router.push({
        path: '/agreement',
        query: { id: 15, temp: new Date().getTime() }
      })
    },
    goAgreement1() {
      this.$router.push({
        path: '/agreement',
        query: { id: 16, temp: new Date().getTime() }
      })
    },
    async getBottomNavList() {
      try {
        const res = await this.$api.home.getBottomNavList()
        if (res.code == 200) {
          this.bottomNavList = res.data
        }
      } catch (error) {
        this.$http.handleError(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.footer-nav {
  width: 100%;
  position: relative;
  margin-top: -2px;

  .footer-nav-content {
    width: 100%;
    background: #48413C;
    padding: 70px 0;

    .footer-nav-content-center {
      width: 1304px;
      margin: 0 auto;

      .footer-columns {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        padding-bottom: 32px;
        border-bottom: 1px solid #6F7782;

        .footer-column {
          flex: 1;
          max-width: 600px;

          .footer-column-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 32px;
            margin-bottom: 24px;
          }

          .footer-column-content {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .footer-column-item {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #FFFFFF;
              line-height: 24px;
              cursor: pointer;
              transition: all 0.3s ease;
              max-width: 300px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              position: relative;

              &:hover {
                color: #458BFF;
                transform: translateX(5px);
              }

              &::after {
                content: attr(title);
                position: absolute;
                left: 0;
                top: 100%;
                background: rgba(0, 0, 0, 0.8);
                color: #fff;
                padding: 5px 10px;
                border-radius: 4px;
                font-size: 14px;
                white-space: normal;
                max-width: 300px;
                z-index: 1000;
                display: none;
              }

              &:hover::after {
                display: block;
              }
            }
          }
        }
      }

      .tk {
        margin-top: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;

        span {
          color: #458BFF;
          cursor: pointer;
        }
      }
    }
  }

  .back-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 96px;
    height: 96px;
    background: #458BFF;
    position: absolute;
    border-radius: 50%;
    color: #FFFFFF;
    font-weight: bold;
    top: -48px;
    left: 50%;
    margin-left: -48px;

    .back-top-icon {
      width: 24px;
      height: 24px;
      background: url('@/assets/home/tops.png') no-repeat center center;
      background-size: 100% 100%;
    }

    .back-top-text {
      margin-top: 8px;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
    }
  }
}
</style>